const CHECKOUT_STEP_CONST = {
    LOGIN_STEP: 'LOGIN_STEP',
    ADDRESS_STEP: 'ADDRESS_STEP',
    PAYMENT_STEP: 'PAYMENT_STEP',
};

export default CHECKOUT_STEP_CONST;
